import { render } from "./AddInscriptionPage.vue?vue&type=template&id=d275971c&ts=true"
import script from "./AddInscriptionPage.vue?vue&type=script&lang=ts"
export * from "./AddInscriptionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__